import { ApiConfig } from "../../../Api/Api";

export const getSemesterApi = async () => {
    return await ApiConfig.get(`api/semester`);
};